import EditCaptionsModal, {
  EditCaptionsModalContainerProps,
} from './EditCaptionsModalContainer';

export { EditCaptionsModalContainerProps };

export default EditCaptionsModal;
